export var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-cache/lib/types/Cache.js
// module id = 692
// module chunks = 0